<template>
    <div class='personal-data'>
        <v-card>
            <div class="box h-full">
                <div class="sub-title" :class="$vuetify.theme.dark ? 'sub-title-d': 'sub-title-l'">
                    <img src="@/assets/img/border.png" alt="">
                    <span>{{$t('personalData.title')}}</span>
                </div>
                <v-row>
                    <v-col cols="12" md="8">
                        <div class="left-content">
                            <div class="d-flex align-baseline pb-3 title-box">
                                <p class="left_title" :class="$vuetify.theme.dark ? '': 'left_title-l'">{{$t('personalData.info')}}</p>
                                <div class="btn-group">
                                    <v-btn v-if="!isEdit" @click="editFun" small height="36" style="padding: 0 8px;" color="primary">
                                        <v-icon size="15" class="icon_edit">{{editIcon}}</v-icon>
                                        {{$t('btn.edit')}}
                                    </v-btn>
                                    <template v-else>
                                        <v-btn v-if="isPhone" color="primary" height="36" small :loading="loadingBtn" @touchstart="subFun">
                                            <v-icon size="15" class="icon_edit">{{saveIcon}}</v-icon>
                                            {{$t('btn.subBtn')}}
                                        </v-btn>
                                        <v-btn v-else color="primary" height="36" small :loading="loadingBtn" @click="subFun">
                                            <v-icon size="15" class="icon_edit">{{saveIcon}}</v-icon>
                                            {{$t('btn.subBtn')}}
                                        </v-btn>
                                        <v-btn outlined height="36" small style="margin-left: 8px;padding: 0 5px;" @click="close">
                                            <v-icon size="15" class="icon_edit">{{cancelIcon}}</v-icon>
                                            {{$t('btn.close')}}
                                        </v-btn>
                                    </template>
                                </div>
                            </div>
                            <v-form
                                class="form-box"
                                ref="ruleForm">
                                <v-container class="pa-0">
                                    <!-- <v-row> -->
                                        <!-- 字段类型，0数字1字符串2日期3布尔4枚举 -->
                                        <div cols="12" md="6" v-for="(itemss, index) in formData" :key="itemss.id" :id="'col'+index">
                                            <div v-if="isEdit && itemss.isMultivalue != 1">
                                                <template v-for="(i,k) in formObj[itemss.attrkey]">
                                                    <div v-if="itemss.type != null" :key="k" :class="[itemss.type == 3 ? 'noedit same_content' : 'content_mul same_content']">
                                                        <template v-if="itemss.type == 2">
                                                            <v-menu
                                                                fixed
                                                                ref="menu"
                                                                v-model="itemss.vMenuTimeVisible[k]"
                                                                :close-on-content-click="false"
                                                                transition="scale-transition"
                                                                offset-y
                                                                min-width="290px"
                                                                :attach="'#col'+index"
                                                                >
                                                                    <template  v-slot:activator="{ on, attrs }">
                                                                        <v-text-field
                                                                            clearable
                                                                            v-model="formObj[itemss.attrkey][k]"
                                                                            readonly
                                                                            outlined
                                                                            dense
                                                                            :disabled="itemss.disabled"
                                                                            :rules="rules[itemss.attrkey]"
                                                                            :label="itemss.attrname"
                                                                            hide-details="auto"
                                                                            v-bind="attrs"
                                                                            style="margin-bottom:10px;"
                                                                            v-on="on">
                                                                        </v-text-field>
                                                                    </template>
                                                                    <v-date-picker
                                                                        v-model="formObj[itemss.attrkey][k]"
                                                                        no-title
                                                                        scrollable
                                                                        :locale="lang"
                                                                        :allowed-dates="itemss.attrkey == 'birthday' ? disabledDate : null"
                                                                        @input="inputMe($event, formObj[itemss.attrkey][k])">
                                                                    </v-date-picker>
                                                            </v-menu>
                                                        </template>
                                                        <template v-else-if="itemss.type == 3">
                                                                <span class="switch_sty">{{itemss.attrname}}</span>
                                                                <v-switch
                                                                    :disabled="itemss.disabled"
                                                                    style="margin-top: 0;background: none;float: left;"
                                                                    hide-details="auto"
                                                                    v-model="formObj[itemss.attrkey][k]"
                                                                >
                                                                </v-switch>
                                                        </template>
                                                        <template v-else-if="itemss.type == 4">
                                                                <v-select
                                                                    :items="itemss.enumEntry"
                                                                    clearable
                                                                    :disabled="itemss.disabled"
                                                                    v-model="formObj[itemss.attrkey][k]"
                                                                    :menu-props="{ top: true, offsetY: true }"
                                                                    :rules="rules[itemss.attrkey]"
                                                                    :label="itemss.attrname"
                                                                    item-text="label"
                                                                    outlined
                                                                    dense
                                                                    hide-details="auto"
                                                                    style="margin-bottom:10px;"
                                                                ></v-select>
                                                        </template>
                                                        <template v-else-if="itemss.type == 0 || itemss.type == 1">
                                                            <v-text-field
                                                                v-model="formObj[itemss.attrkey][k]"
                                                                :rules="rules[itemss.attrkey]"
                                                                :disabled="itemss.disabled"
                                                                :label="itemss.attrname"
                                                                outlined
                                                                clearable
                                                                dense
                                                                hide-details="auto"
                                                                required
                                                                style="margin-bottom:10px;"
                                                            ></v-text-field>
                                                        </template>
                                                    </div>
                                                </template>
                                                <div v-if="itemss.type == null" class="content_mul same_content">
                                                    <v-text-field
                                                        v-model="formObj[itemss.attrkey]"
                                                        :rules="rules[itemss.attrkey]"
                                                        :disabled="itemss.disabled"
                                                        :label="itemss.attrname"
                                                        outlined
                                                        dense
                                                        hide-details="auto"
                                                        required
                                                        style="margin-bottom:10px;"
                                                    ></v-text-field>
                                                </div>
                                            </div>
                                            <div v-else-if="isEdit && itemss.isMultivalue == 1" class="content_mul_tag">
                                                <template v-if="itemss.type == 0 || itemss.type == 1">
                                                    <v-combobox
                                                        style="min-width:45%;"
                                                        v-model="formObj[itemss.attrkey]"
                                                        chips
                                                        clearable
                                                        :error = errors[itemss.attrkey]
                                                        :error-messages = errors2[itemss.attrkey]
                                                        :disabled=itemss.disabled
                                                        :label="itemss.attrname"
                                                        :placeholder="$t('personalData.multivalue')"
                                                        multiple
                                                        outlined
                                                        @change="inputs($event,itemss.attrkey,itemss.type)"
                                                    >
                                                        <template v-slot:selection="{ attrs, item, select, selected }">
                                                            <v-chip
                                                                v-bind="attrs"
                                                                :input-value="selected"
                                                                close
                                                                :title="item"
                                                                small
                                                                @click="select"
                                                                @click:close="() =>remove( item,formObj[itemss.attrkey],itemss.attrkey,itemss.type)"
                                                            >
                                                                <strong>{{ item }}</strong>
                                                            </v-chip>
                                                        </template>
                                                    </v-combobox>
                                                </template>
                                                <template v-if="itemss.type == 2">
                                                    <div>
                                                            <v-menu
                                                                fixed
                                                                ref="menu2"
                                                                v-model="itemss.vMenuTimeVisible"
                                                                :close-on-content-click="false"
                                                                transition="scale-transition"
                                                                offset-y
                                                                min-width="290px"
                                                                :attach="'#col'+index"
                                                            >
                                                                <template v-slot:activator="{ on, attrs }">
                                                                    <v-combobox
                                                                        style="min-width:45%;min-height: 55px;"
                                                                        v-model="formObj[itemss.attrkey]"
                                                                        :error = errors[itemss.attrkey]
                                                                        :error-messages = errors2[itemss.attrkey]
                                                                        multiple
                                                                        chips
                                                                        small-chips
                                                                        :disabled=itemss.disabled
                                                                        outlined
                                                                        :rules="rules[itemss.attrkey]"
                                                                        clearable
                                                                        :placeholder="$t('personalData.multivalue')"
                                                                        :label="itemss.attrname"
                                                                        readonly
                                                                        v-bind="attrs"
                                                                        v-on="on"
                                                                    >
                                                                        <template v-slot:selection="{ attrs, item, select, selected }">
                                                                            <v-chip
                                                                                v-bind="attrs"
                                                                                :input-value="selected"
                                                                                close
                                                                                :title="item"
                                                                                small
                                                                                @click="select"
                                                                                @click:close="() =>remove( item,formObj[itemss.attrkey],itemss.attrkey,itemss.type)"
                                                                            >
                                                                                <strong>{{ item }}</strong>
                                                                            </v-chip>
                                                                        </template>
                                                                    </v-combobox>
                                                                </template>
                                                                <v-date-picker
                                                                    v-model="formObj[itemss.attrkey]"
                                                                    no-title
                                                                    scrollable
                                                                    multiple
                                                                    :locale="lang"
                                                                    @input="inputMe2($event,itemss.attrkey)">
                                                                </v-date-picker>
                                                            </v-menu>
                                                    </div>
                                                </template>
                                            </div>
                                            <div v-else :class="[itemss.type == 3 ? 'content_muls same_content' : 'content_mul_nodeit same_content']">
                                                    <template v-if="itemss.type == 2">
                                                        <v-menu
                                                            fixed
                                                            ref="menu"
                                                            v-model="itemss.vMenuTimeVisible"
                                                            :close-on-content-click="false"
                                                            transition="scale-transition"
                                                            offset-y
                                                            min-width="290px"
                                                            :attach="'#col'+index"
                                                            >
                                                                <template  v-slot:activator="{ on, attrs }">
                                                                    <v-text-field
                                                                        v-model="formObj[itemss.attrkey]"
                                                                        readonly
                                                                        outlined
                                                                        dense
                                                                        disabled
                                                                        :title="itemss.value"
                                                                        :label="itemss.attrname"
                                                                        hide-details="auto"
                                                                        v-bind="attrs"
                                                                        style="margin-bottom:10px;"
                                                                        v-on="on">
                                                                    </v-text-field>
                                                                </template>
                                                                <v-date-picker
                                                                    v-model="formObj[itemss.attrkey]"
                                                                    no-title
                                                                    scrollable
                                                                    :locale="lang"
                                                                    :allowed-dates="itemss.attrkey == 'birthday' ? disabledDate : null"
                                                                    @input="inputMe($event, formObj[itemss.attrkey])">
                                                                </v-date-picker>
                                                        </v-menu>
                                                    </template>
                                                    <template v-else-if="itemss.type == 3">
                                                        <template v-for="(i,k) in formObj[itemss.attrkey]">
                                                            <span  class="switch_sty" :key="k">{{itemss.attrname}}</span>
                                                            <v-switch
                                                                disabled
                                                                style="margin-top: 0;background: none;float: left;"
                                                                hide-details="auto"
                                                                v-model="formObj[itemss.attrkey][k]"
                                                            >
                                                            </v-switch>
                                                        </template>
                                                    </template>
                                                    <template v-else-if="itemss.type == 4">
                                                            <v-text-field
                                                                disabled
                                                                :value="mulVal(itemss.enumEntry,itemss.value)"
                                                                :title="mulVal(itemss.enumEntry,itemss.value)"
                                                                :menu-props="{ top: true, offsetY: true }"
                                                                :label="itemss.attrname"
                                                                item-text="label"
                                                                outlined
                                                                dense
                                                                hide-details="auto"
                                                                style="margin-bottom:10px;"
                                                            ></v-text-field>
                                                    </template>
                                                    <template v-else-if="itemss.type == 0">
                                                        <v-text-field
                                                            v-model="formObj[itemss.attrkey]"
                                                            disabled
                                                            :label="itemss.attrname"
                                                            :title="itemss.value"
                                                            outlined
                                                            dense
                                                            hide-details="auto"
                                                            required
                                                            style="margin-bottom:10px;"
                                                        ></v-text-field>
                                                    </template>
                                                    <template v-else-if="itemss.type == 1">
                                                        <v-text-field
                                                            v-model="formObj[itemss.attrkey]"
                                                            disabled
                                                            :label="itemss.attrname"
                                                            :title="itemss.value"
                                                            outlined
                                                            dense
                                                            hide-details="auto"
                                                            required
                                                            style="margin-bottom:10px;"
                                                        ></v-text-field>
                                                    </template>
                                                <div v-if="itemss.type == null">
                                                    <v-text-field
                                                        v-model="formObj[itemss.attrkey]"
                                                        disabled
                                                        :label="itemss.attrname"
                                                        :title="itemss.value"
                                                        outlined
                                                        dense
                                                        hide-details="auto"
                                                        required
                                                        style="margin-bottom:10px;"
                                                    ></v-text-field>
                                                </div>
                                            </div>
                                        </div>
                                    <!-- </v-row> -->
                                </v-container>
                            </v-form>
                        </div>
                    </v-col>
                    <v-col cols="12" md="4" class="d-flex align-top justify-center">
                        <div class="right-content">
                            <div class="header-box" :style="{'margin-top': $vuetify.breakpoint.smAndUp ? '100px':'10px'}">
                                <img v-if="imageUrl" class="img-url" @click="editImg" :src="imageUrl" alt="avatar" />
                                <div class="text">{{$t('personalData.head')}}</div>
                            </div>
                        </div>
                    </v-col>
                </v-row>
            </div>
        </v-card>
        <v-card>
            <div class="footer" v-if="sourceList">
                <!-- <div class="sub-title">
                    <img src="@/assets/img/border.png" alt="">
                    <span>第三方认证源</span>
                </div> -->
                <p class="left_title" :class="$vuetify.theme.dark ? '': 'left_title-l'">{{$t('personalData.footerTitle')}}</p>
                <div :class="$vuetify.breakpoint.smAndUp ? 'wx-box-pc':'wx-box-m'">
                    <div class="group-list" v-for="(item, index) in sourceList" :key="index">
                        <img class="f-icon" :src="'data:image/png;base64,'+item.authLogo" alt="">
                        <div>
                            <div>{{item.showname}}</div>
                            <!-- <a-popconfirm  :title="$t('personalData.unbindSub')+item.accountsrcName + $t('personalData.source')"
                            overlayClassName="btn-location"  @confirm="unbindFun(item)" :cancelText="$t('btn.close')" :okText="$t('btn.submit')" > -->
                                    <div @click="unbindDialog(item)" class="tip-a">{{$t('personalData.unbind')}}</div>
                            <!-- </a-popconfirm> -->
                        </div>
                    </div>
                </div>
            </div>
        </v-card>
        <!-- 解绑第三方认证源 -->
    	<del-dialog
            :dialogDelete="dialogDelete"
            :dialogTitle="dialogTitle"
            @deleteItemConfirm="unbindFun"
            @close="dialogDelete=false">
        </del-dialog>

        <AvatarModal
            :visible="visible"
            v-if="visible"
            :iconLoading="iconLoading"
            @cancelHandel="cancelHandel"
            @headSave="headSave">
        </AvatarModal>
    </div>
</template>

<script>
import moment from 'moment';
import { userAPI, userAttr, editUser, userPhoto, userUnbind, userSocials, userUpload } from "@/api/index";
import AvatarModal from '@/components/tailorImg/index';
import store from '@/store'
import {setPersistenceCookie} from '@/utils/cookie'
import { mdiPlusCircleOutline,mdiCloseCircle,mdiContentSaveSettings,mdiPencilOutline,mdiBookCancelOutline } from '@mdi/js';
export default {
    components: { AvatarModal },
    data() {
        return {
            addaIcon: mdiPlusCircleOutline,
            closeIcon:mdiCloseCircle,
            editIcon:mdiPencilOutline,
            saveIcon:mdiContentSaveSettings,
            cancelIcon:mdiBookCancelOutline,
            formData: [],
            formObj: {},
            isEdit: false,
            rules: {},
            loading: false,
            imageUrl: '',
            sourceList: [],
            visible: false,
            iconLoading: false,
            flag:false,
            dialogTitle: "",
            dialogDelete: false,
            unbindObj: null,
            menu: false,
            menu2:false,
            lang:"",
            errors:{},
            errors2:{},
            disableds:{},
            loadingBtn:false,
            isPhone:true,
        };
    },
    created() {
        this.getData()
        // 获取个人头像
        this.getPhoto()
        // 获取用户社交认证信息
        this.getSocials()
        this.lang = this.$i18n.locale
        // 判断是否移动端，按钮点击事件触发
        let phoneFlag = /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)
        console.log(/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent))
        if(phoneFlag){
            this.isPhone = true
        }else{
            this.isPhone = false
        }
    },

    methods: {
        moment,

        // 校验数字类型
        checkNum(arr,key){
            let pattern = /^[1-9]\d*$|^0$/
            for(let i=0;i<arr.length;i++){
                let v = arr[i]
                if(!pattern.test(v)){
                    this.errors[key] = true
                    this.errors2[key] = this.$t('personalData.onlyNum')
                }else if (v >　9007199254740991){
                    this.errors[key] = true
                    this.errors2[key] = this.$t('personalData.maxNum')
                }else if (arr.length > 5){
                    this.errors[key] = true
                    this.errors2[key] = this.$t('personalData.maxLength')
                }else{
                    this.errors[key] = false
                    this.errors2[key] = ''
                }
            }
        },
        // 标签删除
        remove(item,arr,key,type) {
            arr.splice(arr.indexOf(item), 1)
            arr = [...arr]
            if(type == 0){
                this.checkNum(arr,key)
            }else{
                this.checkLength(arr,key)
            }
        },
        // 组合框监听标签
        inputs(e,key,type){
            if(type == 0){
                this.checkNum(e,key)
            }else if(type == 1){
                this.checkLength(e,key)
            }
        },
        formatDate(date) {
            if (!date) return null

            const [year, month, day] = date.split('-')
            return `${month}/${day}/${year}`
        },
        getPhoto() {
            userPhoto().then(res=>{
                if (res.code == this.$GLOBA.StatusOK) {
                    this.imageUrl = res.data ? 'data:image/png;base64,'+res.data : require('@/assets/img/head.png')
                    // flag为true的时候代表本身用户有头像，保存即为修改成功
                    this.flag = res.data ? true : false
                }
            })
        },
        getSocials() {
            userSocials().then(res=> {
                if (res.code == this.$GLOBA.StatusOK) {
                    this.sourceList = res.data
                }else{
					store.dispatch('snackbar/openSnackbar',{
						snackbarText: res.message,
						colorType: 'error'
					})
                }
            })
        },
        getData() {
            let list = {}
            userAttr().then(res=> {
                // userAPI().then(res2=> {
                    let arrList = {}
                    for (let item of res.data) {
                        item.disabled = true
                         item.vMenuTimeVisible = false
                        // 字段类型，0数字1字符串2日期3布尔4枚举
                        if(item.type == 4) {
                            if(!item.value){
                                item.value = ['']
                            }
                            item.enumEntry = JSON.parse(item.enumEntry)

                        } else if (item.type == 2) {
                            if(item.value){
                                for(let i=0;i<item.value.length;i++){
                                    if(item.value[i]){
                                        item.value[i] = item.value[i] == 0 ? null : moment(item.value[i] * 1000).format('YYYY-MM-DD')
                                    }else{
                                        item.value[i] = null
                                    }
                                }
                            }else if(item.isMultivalue != 1){
                                item.value = ['']
                            }else{
                                item.value = []
                            }
                            // item.value = item.value ? (item.value == 0 ? null : moment(item.value * 1000).format('YYYY-MM-DD')) : null
                        } else if (item.type == 3) {
                            if(item.value){
                                for(let i = 0; i<item.value.length;i++){
                                    if(item.value[i] == "true"){
                                        item.value[i] = true
                                    }else{
                                        item.value[i] = false
                                    }
                                }
                            }else{
                                item.value = [false]
                            }

                        }else if(item.type == 1){
                            if(!item.value && item.isMultivalue != 1){
                                item.value = ['']
                            }
                        }else if(item.type == 0) {
                            if(!item.value && item.isMultivalue != 1){
                                item.value = ['']
                            }
                            if( list[item.attrkey]) {
                                list[item.attrkey].push(
                                    v => this.checkUserInputNum(v),
                                )
                            }else{
                                list[item.attrkey] = [v => this.checkUserInputNum(v)]
                            }
                        }
                        // 过滤必填项 isMust=1、3必填
                        if (item.attrkey == 'username') {
                            list[item.attrkey] = [
                                v => !!v || this.$t('personalData.import')+item.attrname,
                                v => /^[\u4E00-\u9FA5A-Za-z0-9!@#$%^&*()_.]{1,32}$/.test(v) || this.$t('personalData.rulesFun')
                            ]
                        } else if(item.isEdit == 1 || item.isEdit == 3) {
                            if(item.isMust == 1 || item.isMust == 3) {
                                let msg = item.type == 2 ? this.$t('personalData.select')+item.attrname : item.type == 4 ? this.$t('personalData.select')+item.attrname : this.$t('personalData.import')+item.attrname
                                list[item.attrkey] = [
                                    v => !!v || msg,
                                ]
                            }
                        }
                        arrList[item.attrkey] = item.value
                    }
                    this.rules = list
                    this.formData = res.data
                    this.formObj = arrList
                // })
            })
        },
        mulVal(enumEntry,value){
            let mulVal = []
            for(let i=0;i<enumEntry.length;i++){
                for(let k = 0;k<value.length;k++){
                    if(value[k] == enumEntry[i].value){
                        mulVal.push(enumEntry[i].label)
                    }
                }
            }
            return mulVal
        },
        editFun() {
            this.isEdit = true
            this.errors = {}
            this.errors2 = {}
            for (let item of this.formData) {
                if(item.isEdit == 1 || item.isEdit == 3) {
                    item.disabled = false
                }else{
                    item.disabled = true
                }
            }
        },
        getBase64(img, callback) {
            const reader = new FileReader();
            reader.addEventListener('load', () => callback(reader.result));
            reader.readAsDataURL(img);
        },
        // 校验必填项
        required(){
            for (let item of this.formData) {
                if(item.isEdit == 1 || item.isEdit == 3){
                    if(item.isMust == 1 || item.isMust == 3){
                        if(!this.formObj[item.attrkey] || this.formObj[item.attrkey].length == 0){
                            this.errors  = Object.assign({},this.errors,{
                                [item.attrkey]:true
                            })
                            this.errors2 = Object.assign({},this.errors2,{
                                [item.attrkey]:item.attrname + this.$t('personalData.requireTrue')
                            })
                        }
                    }
                }
            }

        },
        subFun() {
            this.loadingBtn = true
            // 校验必填项
            this.required()
            // 判断自写校验
            let num = 0
            for(let i in this.errors){
                if(this.errors[i]){
                    num++
                }
            }
            if (this.$refs.ruleForm.validate() && num == 0) {
                 let subObj = new Object()
                for (let item of this.formData) {
                    if (item.type == 2) {
                        subObj[item.attrkey] = []
                        if(item.isMultivalue == 1 && this.formObj[item.attrkey]){
                            for(let v of this.formObj[item.attrkey]){
                                if(v){
                                    subObj[item.attrkey].push((moment(v).valueOf())/1000)
                                }
                            }
                        }else if(item.value.length == 1 && !item.value[0]){
                            subObj[item.attrkey] = []
                        }else{
                            for(let v of item.value){
                                if(v){
                                    subObj[item.attrkey].push((moment(v).valueOf())/1000)
                                }
                            }
                        }
                    }
                    if(item.type == 4){
                        subObj[item.attrkey] = item.value
                    }
                    if(item.type == 1){
                        if(item.isMultivalue == 1 && this.formObj[item.attrkey]){
                            subObj[item.attrkey] = this.formObj[item.attrkey]
                        }else if(!item.value){
                            subObj[item.attrkey] = []
                        }else{
                            subObj[item.attrkey] = item.value
                        }
                    }
                    if(item.type == 0){
                        if(item.isMultivalue == 1 && this.formObj[item.attrkey]){
                            subObj[item.attrkey] = this.formObj[item.attrkey].map(Number)
                        }else if( !item.value || (item.value.length == 1 && !item.value[0])){
                            subObj[item.attrkey] = []
                        }else{
                            subObj[item.attrkey] = item.value.map(Number)
                        }
                    }
                    if(item.type == 3){
                        subObj[item.attrkey] = item.value
                    }
                }
                // // 删除组织机构
                // delete subObj.organization
                editUser(subObj).then(res=> {
                    if (res.code == this.$GLOBA.StatusOK) {
                        this.loadingBtn = false
                        store.dispatch('snackbar/openSnackbar',{
                            snackbarText: res.message,
                            colorType: 'success'
                        })
                        let listData = this.$cookieStore.getCookie("userInfo")
                        listData.username = subObj.username[0]
                        // this.$cookieStore.setCookie('userInfo', listData)
                        setPersistenceCookie('userInfo', listData)
                        let attr = {username:subObj.username[0], email:subObj.email[0], phonesn:subObj.phonesn[0]}
                        this.$cookieStore.setCookie('userAttr', attr)
                        this.$root.eventHub.$emit('usernameChange', subObj.username[0]);
                        this.getData()
                        this.isEdit = false
                    } else {
                        store.dispatch('snackbar/openSnackbar',{
                            snackbarText: res.message,
                            colorType: 'error'
                        })
                        this.loadingBtn = false
                    }
                })
            }else{
                this.loadingBtn = false
            }
        },
        close() {
            this.isEdit = false
            this.$refs.ruleForm.resetValidation()
            this.getData()
        },
        unbindFun(val) {
            userUnbind({
                socialId: this.unbindObj.id
            }).then(res=> {
                if (res.code == this.$GLOBA.StatusOK) {
                    store.dispatch('snackbar/openSnackbar',{
                        snackbarText: res.message,
                        colorType: 'success'
                    })
                    this.dialogDelete = false
                    this.getSocials()
                }else{
                    store.dispatch('snackbar/openSnackbar',{
                        snackbarText: res.message,
                        colorType: 'error'
                    })
                    this.dialogDelete = false
                }
            })
        },
        unbindDialog(val) {
            this.unbindObj = val
            this.dialogTitle = this.$t('personalData.unbindSub')+val.accountsrcName + this.$t('personalData.source')
            this.dialogDelete = true
        },
        // rulesFun(rule, value, callback) {
        //     if(!value){
        //         callback()
        //         return;
        //     }
        //     if(!/^[\u4E00-\u9FA5A-Za-z0-9!@#$%^&*()_.]{1,32}$/.test(value)){
        //         callback(this.$t('personalData.rulesFun'))
        //     }
        //     callback();
        // },

        checkUserInputNum(value){
            if(!value){
                return true;
            }
            let pattern = /^[1-9]\d*$|^0$/
            if(!pattern.test(value)){
                return this.$t('personalData.onlyNum')
            }
            if (value >　9007199254740991){
                return this.$t('personalData.maxNum')
            }

            return true;
        },
        editImg() {
            this.visible = true
        },
        cancelHandel() {
            this.visible = false
        },
        headSave(file) {
            this.iconLoading = true
            let params = new FormData()
            params.append("photo", file)
            userUpload(params).then(res=>{
                this.iconLoading = false
                if (res.code == this.$GLOBA.StatusOK) {
                    if(this.flag){
                        store.dispatch('snackbar/openSnackbar',{
                            snackbarText: this.$t('personalData.editSuc'),
                            colorType: 'success'
                        })
                    }else{
                        store.dispatch('snackbar/openSnackbar',{
                            snackbarText: this.$t('personalData.addSuc'),
                            colorType: 'success'
                        })
                    }

                    this.cancelHandel()
                    this.getBase64(file, imageUrl => {
                        this.imageUrl = imageUrl;
                        this.loading = false;
                        this.$root.eventHub.$emit('headImgChange', imageUrl);
                    })
                } else {
                    store.dispatch('snackbar/openSnackbar',{
                        snackbarText: res.message,
                        colorType: 'error'
                    })
                    return false
                }
            }).catch( error=> {
                this.iconLoading = false
            })
        },
        disabledDate(current) {
            return current && (current < moment().endOf('day').format('YYYY-MM-DD'))
        },
        inputMe(k, v) {
            v = this.formatDate(k)
            this.menu = false
        },
        inputMe2(k,key){
            this.menu2 = false
            this.checkLength(k,key)
        },
        checkLength(arr,key){
            if(arr.length > 5){
                this.errors[key] = true
                this.errors2[key] = this.$t('personalData.maxLength')
            }else{
                this.errors[key] = false
                this.errors2[key] = ''
            }
        }
    },
}
</script>

<style lang='scss' scoped>
.personal-data {
    /*overflow: hidden;*/
  height: 100%;
}
.title {
    margin-bottom: 30px;
}
.sub-title {
    font-size: 18px;
    font-weight: 600;
    padding: 8px 0 8px 30px;
    display: flex;
    align-items: center;
    border-radius: 7px 7px 0 0;
    span {
        margin-left: 10px;
    }
}
.sub-title-l {
    background: #dce0f9;
    color: #333;
}
.sub-title-d {
    border-bottom: 1px solid #f0f0f0;
}
.box {
    // background: #FFFFFF;
    box-shadow: 0px 0px 46px 0px rgba(0, 0, 0, 0.05);
    border-radius: 7px;
    padding: 0px 0px 30px;
    display: flex;
    flex-direction: column;
    margin-bottom: 30px;
    position: relative;
    width: 100%;
    .form-box ::v-deep {
        padding: 0 52px;
        .ant-form-item {
            width: 34%;
            margin-right: 3%;
            display: inline-block;
            margin-bottom: 12px;
        }
        .ant-form-item-label {
            width: 100%;
            white-space: normal;
            line-height: 24px;
            text-align: left;
            word-wrap: break-word;
        }
        .ant-switch-checked {
            background: #5066e0;
        }
    }
    .left-content {
        .left_title{
            // padding-left: 52px;
            font-size: 18px;
            margin-top: 30px;
            font-weight: bold;
            // flex: 1;
        }
        .left_title-l {
            color: #333;
        }
        .btn-group{
            margin-left: 30px;
        }
    }
    .right-content {
        // flex: 1;
        // position: absolute;
        // top: 76px;
        // right: 0;
        .btn-group {
            // position: absolute;
            // top: 30px;
            // right: 30px;
            display: flex;

        }
        .header-box {
            // position: absolute;
            // top: 100px;
            // right: 110px;
            // margin-top: 100px;
            text-align: center;
            .img-url {
                width: 160px;
                height: 160px;
                border-radius: 50%;
                cursor: pointer;
            }
            .text {
                margin-top: 10px;
            }
        }
    }
}
.footer {
    // background: #FFFFFF;
    box-shadow: 0px 0px 46px 0px rgba(0, 0, 0, 0.05);
    border-radius: 6px;
    padding: 30px 20px 25px;
    // float: left;
    width: 100%;
    .left_title{
        padding-left: 52px;
        font-size: 18px;
        font-weight: bold;
    }
    .left_title-l {
        color: #333;
    }
    .group-list {
        padding-left: 40px;
        display: flex;
        align-items: center;
        font-weight: 600;
        .f-icon {
            margin-right: 17px;
            width: 70px;
            height: 70px;
            border-radius: 50%;
            // border: 1px solid #ebebeb;
        }
        .tip-a {
            color: #5066e0;
            margin-top: 5px;
            cursor: pointer;
        }
    }
    .wx-box-pc {
        display: flex;
    }
    .wx-box-m {
        .group-list {
            margin-bottom: 10px;
        }
    }
}
::v-deep .ant-btn-primary{
    background: #5066e0;
    border-color: #5066e0;
}
::v-deep .btn-group:nth-child(2){
    border-color: #5066e0;
    color: #5066e0;
}
.title-box {
    padding-right: 52px;
    padding-left: 52px;
}
.switch_sty{
    color: #5e5669ad;
    font-size: 14px;
    float: left;
    margin-top: 5px;
    margin-right: 5px;
    max-width: 40%;
    word-wrap: break-word;
    white-space: normal;
}

.theme--dark{
  .switch_sty{
    color: rgba(231, 227, 252, 0.5);

  }
}
.close_icon{
    position: relative;
    top: -45px;
    right: -101%;
}
.addIcon{
    position: relative;
    top: -45px;
    right: -101%;
}
.same_content{
    min-width: 45%;
    max-width: 45%;
    float: left;
    margin-right: 40px;
    height:55px;
    max-height: 248px;
}
.content_mul{
    margin-bottom:30px;
    margin-top: 5px;
}
.content_mul_nodeit{
    margin-bottom:8px;
    margin-top: 25px;
}
.content_mul_tag{
    min-width: 45%;
    max-width: 45%;
    float: left;
    margin-right: 40px;
    margin-top: 4px;
    ::v-deep{
        .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded) > .v-input__control > .v-input__slot{
          margin-bottom: 4px;
        }
    }
}
.content_muls{
    margin-bottom:8px;
    margin-top: 25px;
}
.noedit{
    margin-bottom:10px;
    margin-top: 20px;
}
.content_mul1{
    min-width: 45%;
    float: left;
    margin-right: 40px;
}
.icon_edit{
    margin-top: 2px;
    margin-right: 3px;
}
@media screen and (min-width: 320px) and (max-width: 480px){
    .content_muls{
        max-height: 287px;
    }
    .switch_sty{
        max-width: 59%;
    }
    .same_content{
        min-width: 100%;
        max-width: 100%;
    }
    .content_mul_tag{
        min-width: 100%;
        max-width: 100%;
    }
}
::v-deep {
    .v-input.error--text .v-text-field__details{
        padding: 0;
    }
    .v-select.v-select--chips:not(.v-text-field--single-line).v-text-field--enclosed .v-select__selections{
        min-height: 50px;
    }
    .v-select__slot{
        min-height:42px;
    }
    .v-application--is-ltr .v-text-field--outlined fieldset{
        height: 46px;
    }
    .v-application--is-ltr .v-text-field--outlined fieldset{
        margin-top: 0;
    }
    .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded) > .v-input__control > .v-input__slot{
        min-height:55px;
    }
    .v-chip .v-chip__content{
        strong{
            max-width: 130px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }
    .v-text-field--outlined.v-input--dense .v-label{
        top:18px;
    }
    .v-text-field--outlined.v-input--dense .v-label--active{
        top:10px !important;
    }
    .v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__append-inner{
        margin-top: 16px;
    }
    .v-input.error--text .v-text-field__details{
        margin-bottom: 8px;
    }
    .theme--light.v-text-field--outlined:not(.v-input--is-focused).v-input--is-disabled > .v-input__control > .v-input__slot fieldset{
        background: #f5f5f5;
    }
}
@media screen and (min-width: 320px) and (max-width: 480px) {
    .box .left-content .btn-group{
        margin-left: 10px;
        .v-btn{
            padding: 0 10px;
            font-size: 12px;
        }
    }
    .box .left-content .title-box{
        padding-right: 25px;
    }
}
</style>
